import type {NamedLabeled} from 'typings/portaro.be.types';
import {exists} from 'shared/utils/custom-utils';

export class NetworkConnectionError extends Error implements NamedLabeled {
    constructor(public text: string, public cause?: string) {
        super(exists(cause) ? `Network Connection Error: ${cause}` : 'Network Connection Error');
        this.name = NetworkConnectionError.name;
    }
}